import { ProductFlag } from 'src/components/product/ProductTitle/ProductFlag'
import type { Flag } from 'src/components/product-page/context/types/product.type'
import { Link } from 'gatsby'
import { formatterPrice } from 'src/utils/formatterPrice'
import { Image } from 'src/components/ui/Image'
import { useProductLink } from 'src/sdk/product/useProductLinkV2'
import type { Product } from 'src/components/restructure/product/types/product'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

interface DiscoveryHubProductCardProps {
  product: Product
  index: number
  setCloseSearchHubModal: (isCloseModal: boolean) => void
  shelfTitle: string
}

export default function DiscoveryHubProductCard({
  product,
  index,
  setCloseSearchHubModal,
  shelfTitle,
}: Readonly<DiscoveryHubProductCardProps>) {
  const { items, linkText, productName } = product
  const { pageData } = useGlobalContext()
  const firstAvailable = items?.find((item) => item.isAvailable) ?? items[0]

  const {
    sellerDefault: {
      sellerOffer: { cashPrice, listPrice },
    },
    flags,
    images,
  } = firstAvailable

  const link = useProductLink({
    slug: linkText,
    type: pageData.currentPageType,
    shelfRef: `Vitrine - ${shelfTitle}`,
    currentSku: firstAvailable,
    index,
    product,
    shelfEngine: 'dy',
    handleClick: () => setCloseSearchHubModal(false),
  })

  const hasPrice = cashPrice > 0
  const hasListPrice = listPrice > 0 && listPrice !== cashPrice

  const filterPromotionFlag = (array: Flag[]) => {
    return array.filter((item) => /^(?=.{1,7}$).*OFF.*/.test(item.value))
  }

  return (
    <Link {...link} className="flex flex-col items-center justify-center gap-2">
      <div className="relative">
        {flags && flags.length > 0 && (
          <ProductFlag flags={filterPromotionFlag(flags)} />
        )}
        <div className="relative bg-[#eeeff0] w-[107px] h-[107px]">
          <Image
            className="w-full h-full mix-blend-multiply object-contain"
            src={images[0].imageUrl}
            alt={productName}
            width={107}
            height={107}
            loading="eager"
          />
        </div>
        <div className="mt-xs flex flex-col items-start gap-xs">
          {hasPrice && (
            <p className="font-medium text-xs text-restructure-primary">
              {formatterPrice(cashPrice)}
            </p>
          )}
          {hasListPrice && (
            <p className="font-medium text-xs text-tertiary line-through">
              {formatterPrice(listPrice)}
            </p>
          )}
        </div>
      </div>
    </Link>
  )
}
